<template>
  <div class="error-section">
    <table v-if="errors.length > 0" class="log-table">
      <thead>
        <tr>
          <th>{{ $t('MaintenanceDeviceErrors.error_code') }}</th>
          <th>{{ $t('MaintenanceDeviceErrors.error_description') }}</th>
          <th>{{ $t('MaintenanceDeviceErrors.help_url') }}</th>
          <th>{{ $t('MaintenanceDeviceErrors.date') }}</th>
          <th>{{ $t('MaintenanceDeviceErrors.time') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="errorEvent in errors" :key="errorEvent.device_time">
          <td>{{ errorEvent.error_code }}</td>
          <td>{{ errorEvent.error_description }}</td>
          <td><a :href="errorEvent.error_help_link" target="_blank">{{ $t('MaintenanceDeviceErrors.help') }}</a></td>
          <td>{{ formatLocalDate(errorEvent.device_date_time) }}</td>
          <td>{{ formatLocalTime(errorEvent.device_date_time) }}</td>
        </tr>
      </tbody>
    </table>
    <p v-else>{{ $t('MaintenanceDeviceErrors.no_errors_found') }}</p>
  </div>
</template>

<script>
import { backendUrl } from '../config/envVariablesConfig';
import axios from 'axios';
import keycloak from '@/keycloak';
export default {
  props: {
    deviceId: String
  },
  data() {
    return {
      intervalId:null,
      errors: [] // Store error logs from API
    }
  },
  async mounted() {
    await this.fetchErrorForDevice();
    this.intervalId = setInterval(this.fetchErrorForDevice, 5000);
  },
  beforeUnmount(){
    clearInterval(this.intervalId);
  },
  methods: {
    /// Emit events that trigger top level functions
    showError(message) {
      this.$emit('showError', message);
    },
    showSuccess(message) {
      this.$emit('showSuccess', message);
    },
    async fetchErrorForDevice() {
      try {
        await keycloak.updateToken(30);
        const response = await axios.get(
          `${backendUrl}/api/device/error`,
          {
            params: { id: this.deviceId }, // Pass deviceId as a query parameter
            headers: {
              Authorization: `Bearer ${keycloak.token}`
            }
          });

        // Validate response data
        if (!response.data || !response.data.data) {
          this.showError(this.$t('MaintenanceDeviceErrors.invalid_response_structure'));
          return;
        }

        if (!response.data.success) {
          this.showError(this.$t('MaintenanceDeviceErrors.response_with_error')`: ${response.data.error}`);
          return;
        }

        // Store the fetched logs in the component's state
        this.errors = response.data.data; // Assuming logs is a data property in your component
      } catch (error) {
        console.error(`fetchLogsForDevice: ${error}`); // Log the error for debugging
        this.showError(this.$t('MaintenanceDeviceErrors.internal_error_fetching'));
      }
    },
    formatLocalDate(utcDateTime) {
      const date = new Date(utcDateTime);
      return date.toLocaleDateString();
    },
    formatLocalTime(utcDateTime) {
      const date = new Date(utcDateTime);
      return date.toLocaleTimeString();
    }
    //#endregion

  }
};
</script>

<style scoped>
.log-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.log-table th,
.log-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.log-table th {
  background-color: #e74c3c;
  color: white;
}

.log-table tr:hover {
  background-color: #f1f1f1;
}

.log-table td {
  color: #333;
}

.log-section p {
  color: #7f8c8d;
  font-style: italic;
}
</style>